import { useEffect } from 'react';
import { Fancybox as NativeFancybox } from '@fancyapps/ui/dist/fancybox.esm.js';
import '@fancyapps/ui/dist/fancybox.css';



function CoolLightBox({ delegate, options, children }) {
  const delegate_ = delegate || '[data-fancybox]';

  useEffect(() => {
    const opts = options || {};
    NativeFancybox.bind(delegate_, opts);

    return () => {
      NativeFancybox.destroy();
    };
  }, []);

  return <>{children}</>;
}

export default CoolLightBox;
